export default "__VITE_ASSET__e647b533__"